import React from "react";
import DocDetailsProps from "./DocDetailsProps";
import UserCmDoc from "../../entities/UserCMDoc";
import { dateFormatter } from "../../utils/helpers/dateFormatter";
import WhitePdfButton from "../WhitePdfButton/WhitePdfButton";
import BlackPdfButton from "../BlackPdfButton/BlackPdfButton";
import reportsIcon from "../../assets/images/reports-black-icon.png";
import { getFundLabel } from "../../utils/helpers/getFundLabel";
import { convertMonth } from "../../utils/helpers/monthConverter";
import { useTranslation } from "react-i18next";

import "./DocDetails.scss";

const label106 = "/טופס 106";

const DocDetails = (props: DocDetailsProps) => {
  const { i18n } = useTranslation("common");

  const mapFundName = () =>{
    if(props.fundName && props.mainDoc.FundCode)
    return props.fundName.map(item=> {return props.mainDoc.FundCode === item.fundID ? i18n.language === "he"? item.fundNameHeb: item.fundNameArabic: null })
   }
  
  const renderBlackPdfButton = (year: number, displayName: string) => {
    if (props.userAttachedReports && props.userAttachedReports.length) {
      const docFilteredByYear: UserCmDoc[] = props.userAttachedReports.filter(
        (attachedDoc: UserCmDoc) =>
        year === attachedDoc.YearDocDate && displayName.includes("דוח לחבר שנתי")
        );
      if (docFilteredByYear.length) {
        return <BlackPdfButton PId={Number.parseInt(docFilteredByYear[0].PId)}/>;
      }
    }
    return null;
  };
  return (
    <>
      <li className="details" key={props.mainDoc?.PId}>
        <div className="details-right">
          <span className="details-right-text-date">
            {dateFormatter(props?.mainDoc?.DocDate)}
          </span>
          <div className="text-right">
            <img src={reportsIcon} className="reports-icon" alt="" role="presentation" aria-hidden="true"/>
            <div className="text-right-wrapper">
              {
              // props.fromTlushiPension &&
              // props?.mainDoc?.DocDate?.split("-")[1] === "12" ? (
              //   <>
              //     <span className="main-right-text">
              //       {props?.mainDoc?.DocDisplayName}
              //       {label106}
              //     </span>
              //   </>
              // ) : 
              (
                <>
                  <h2 className="main-right-text">
                    {props?.mainDoc?.DocDisplayName}{" "}
                    {`${convertMonth(
                      parseInt(props.mainDoc.DocDate.split("-")[1]),
                      i18n.language
                    )}`}{" "}
                    {props.mainDoc.DocDate.split("-")[0]}
                  </h2>
                </>
              )}

              <span className="sub-right-text">
                {mapFundName()}
              </span>
            </div>
          </div>
        </div>
        <div className="details-left">
          {props.fromReports &&
            props.userAttachedReports &&
            props.userAttachedReports.length ?
            renderBlackPdfButton(
              props.mainDoc.YearDocDate,
              props.mainDoc.DocDisplayName
            ) : null}
          {props.mainDoc.PId ? <WhitePdfButton PId={Number(props.mainDoc.PId)} /> : null}
          

        </div>
      </li>
    </>
  );
};

export default DocDetails;
